import { ContractTaxonomyFragment } from 'generated/resources/graphql'
import type moment from 'moment'

import type SupplementForm from 'modules/payroll_bundle/components/Handoffs/Supplements/Forms/SupplementForm'
import type SupplementsFormStore from 'modules/payroll_bundle/components/Handoffs/Supplements/Forms/store'
import Line from './Line'

interface Props {
  forms: SupplementForm[]
  store: SupplementsFormStore
  taxonomies: ContractTaxonomyFragment[]
  itemToHighlight?: { supplementId: number } | null
  readonly: boolean
  date: moment.Moment
  frequency: string
  hover: boolean
  toggleTaxonomyCreationModal: (value: boolean) => void
}

export default function FormLines({
  forms,
  store,
  taxonomies,
  itemToHighlight,
  readonly,
  date,
  frequency,
  hover,
  toggleTaxonomyCreationModal,
}: Props) {
  const size = forms.length - 1

  forms.sort((a, b) => {
    return b.get('created_at').value.localeCompare(a.get('created_at').value)
  })

  return (
    <>
      {forms.map((form: SupplementForm, i: number) => (
        <Line
          date={date}
          frequency={frequency}
          readonly={readonly}
          key={form.get('id').value || form.get('created_at').value || i}
          store={store}
          taxonomies={taxonomies}
          itemToHighlight={itemToHighlight}
          form={form}
          isLast={i === size}
          hover={hover}
          toggleTaxonomyCreationModal={toggleTaxonomyCreationModal}
        />
      ))}
    </>
  )
}
